import { api } from './requestGraphql';

const getOfferVariants = async (offerId) => {
    try {
        const res = await api.post('', {
            query: `
                {
                    getOfferVariants(offerId: ${offerId}) {
                        id
                        offerId
                        name
                        imageName
                        isDefault
                        preSignedUrl
                        permanentUrl
                        params
                    }
                }
            `,
        });

        let response = res.data.data.getOfferVariants;
        console.log(`getOfferVariants response: `, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};
const offerVariantImageUploadUrl = async (id, name, extension, method) => {
    try {
        const res = await api.post('', {
            query: `
                mutation {
                    offerVariantImageUploadUrl(id: ${id}, name: "${name}", extension: "${extension}", method: "${method}")
                }
            `,
        });

        let response = res.data.data.offerVariantImageUploadUrl;
        console.log(`offerVariantImageUploadUrl response: `, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const createOfferVariant = async (offerId, name) => {
    try {
        const res = await api.post('', {
            query: `
                mutation {
                    createOfferVariant(offerId: ${offerId}, name: "${name}") {
                        success
                        id
                        message
                    }
                }
            `,
        });

        let response = res.data.data.createOfferVariant;
        console.log(`createOfferVariant response: `, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const deleteOfferVariant = async (id) => {
    try {
        const res = await api.post('', {
            query: `
                mutation {
                    deleteOfferVariant(id: ${id})
                }
            `,
        });

        let response = res.data.data.deleteOfferVariant;
        console.log(`deleteOfferVariant response: `, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};


const updateOfferVariant = async (id, name, oldName, imageName, params, isDefault, offerId) => {
    const escapedParams = params ? params.replace(/"/g, '\\"'): [];
    const booleanIsDefault = Boolean(isDefault);
    try {
        const res = await api.post('', {
            query: `
                mutation {
                    updateOfferVariant(
                        id: ${id}, name: "${name}", oldName:"${oldName}", imageName: "${imageName}", 
                        params: "${escapedParams}", isDefault: ${booleanIsDefault}, 
                        offerId: ${offerId}
                    ) {
                        success
                        id
                        message
                    }
                }
            `,
        });

        let response = res.data.data.updateOfferVariant;
        console.log(`updateOfferVariant response: `, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};
export default {
    getOfferVariants,
    offerVariantImageUploadUrl,
    createOfferVariant,
    updateOfferVariant,
    deleteOfferVariant
};
